<template>
  <HeaderDropdownButton text="Cabinets" :items="dropdownButtons"/>
</template>

<script setup>
  import HeaderDropdownButton from "@/components/base-components/header/HeaderDropdownButton.vue";
  import { computed } from "vue";
  import { useRoute, useRouter } from 'vue-router';
  import { storeToRefs } from 'pinia';
  import { useHeaderStore } from "@/stores/headerStore.js";
  import { useCabinetsPageStore } from "@/stores/cabinetsPageStore.js";

  const cabinetsPageStore = useCabinetsPageStore()
  const headerStore = useHeaderStore()
  const { recentCabinetList } = storeToRefs(headerStore)

  const route = useRoute()
  const router = useRouter()

  const dropdownButtons = computed(() => {
    const cabinetItems = recentCabinetList.value.map(cabinet => ({
      text: cabinet.name,
      route: { name: 'search', params: { cabinetId: cabinet.cabinet_id } }
    }))

    return [
      ...cabinetItems,
      {
        text: 'Add Cabinet',
        icon: 'add',
        onClick: () => {
          cabinetsPageStore.setOpenNewCabinetPopup(true)
          if (route.name !== 'cabinets')
            router.push({ name: 'cabinets' })
        }
      }
    ]
  })
</script>

<style scoped lang="scss">

</style>
